import { app } from '@store/modules/app';
import { genericErrorToast } from '@constants';
import { investmentEntity } from '@store/modules/investment-entity';
import { ira } from '@store/modules/ira';
import { RouteConfig } from 'vue-router';
import { user } from '@store/modules/user';

const getFirstPendingVerificationIraInvestmentEntityId = (): string => {
	const pendingVerificationIraEntities = user.user?.entityDetails.investmentEntities.find(
		(entity) => entity.iraEntityMetadata?.verificationStatus === 'AWAITING_DOCUMENTATION'
	);
	return pendingVerificationIraEntities ? pendingVerificationIraEntities.investmentEntityId : '';
};

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const iraVerifyRoutes: RouteConfig = {
	path: `/ira/verify`,
	name: 'ira-verify',
	meta: { minTokenScopeRequired: 'FULL_ACCESS' },
	beforeEnter: async (to, from, next) => {
		const pendingVerificationInvestmentEntityId = getFirstPendingVerificationIraInvestmentEntityId();
		if (pendingVerificationInvestmentEntityId === '') {
			next({ name: 'account-overview', replace: true });
			app.ADD_TOAST({
				type: 'error',
				message: 'No IRA for verification is available.'
			});
		} else {
			if (investmentEntity.investmentEntityId !== pendingVerificationInvestmentEntityId) {
				await user.updateSelectedEntity(pendingVerificationInvestmentEntityId);
			}

			ira.UPDATE_FLOW('VERIFY');
			if (!ira.dataRetrieved) {
				try {
					await ira.getVerifyFlowInfo();
				} catch (error) {
					next({ name: 'account-overview', replace: true });
					app.ADD_TOAST(genericErrorToast);
				}
			}
			await next();
		}
	},
	component: () => import(/* webpackChunkName: "ira-verify-start" */ '@views/ira/verify/ira-verify-start.vue'),
	children: [
		{
			path: `documents`,
			name: 'ira-verify-documents',
			meta: { minTokenScopeRequired: 'FULL_ACCESS' },
			beforeEnter: async (to, from, next) => {
				if (ira.verificationStatus === 'AWAITING_DOCUMENTATION') {
					await next();
				} else {
					await next({ name: 'ira-verify-success', replace: true });
				}
			},
			component: () => import(/* webpackChunkName: "ira-documents" */ '@views/ira/signup/ira-documents.vue')
		},
		{
			path: `success`,
			name: 'ira-verify-success',
			meta: { minTokenScopeRequired: 'FULL_ACCESS' },
			component: () =>
				import(/* webpackChunkName: "ira-verify-success" */ '@views/ira/verify/ira-verify-success.vue')
		}
	]
};

export default iraVerifyRoutes;
